import { Component, ViewChild, Renderer } from '@angular/core';
import { NavController, Slides, NavParams, ViewController, MenuController  } from 'ionic-angular';
import { CustomAlert } from '../../components/custom-alert.component';
import { Storage } from '@ionic/storage';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'

//Providers
import { ConfigProvider } from '../../providers/config-provider';
import { UtilProvider } from '../../providers/util-provider';
import { CongressoProvider } from '../../providers/congresso-provider';
import { SearchProvider } from '../../providers/search-provider';
import { GeralProvider } from '../../providers/geral-provider';


@Component({
    selector: 'page-sobre',
    templateUrl: 'sobre.html'
})

export class SobrePage {
    private urlFundo: string = "url(assets/images/app-sobre-fundo.png)";
    private urlCell: string = "url(assets/images/app-sobre-celular.png)";
    public message: string;

    constructor(private navParams: NavParams, public viewCtrl: ViewController, public sanitizer: DomSanitizer, public util: UtilProvider) {

    }

    dismiss() {
        this.viewCtrl.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/sobre/sobre.ts